


















































































































































import {
  Component, Prop, mixins, Watch,
} from '@samclick-commons';
import {
    AuthorizationStore,
    Payload,
    MyaaffiliateStore,
    CommonsStore, NewsStore,
} from '@samclick-store-factory';
import SamclickMixins from '@/utils/mixins';
import * as appStorageUtil from '@/utils/localstorage-util';
import TermsAndCondition from '@/views/Login/TermsAndCondition.vue';
import { _isEmpty } from '@/plugins/lodash';
import { getLanguageLookup, isBoa } from '@/utils/common-utils';
import {removeAuthentication} from "@/api-client/api";
import enLocale from '@/locales/en.json';
import jaLocale from '@/locales/ja.json';

@Component({
  components: { TermsAndCondition },
})
export default class Login extends mixins(SamclickMixins) {
  private static readonly AFFILIATE_STATUS_UNVERIFIED = 1;
  private static readonly AFFILIATE_STATUS_VERIFIED = 2;

  $refs!: {
    ruleForm2: any;
    otpForm: any;
  };

  items: Array<LooseObject> = [
    {
      label: 'lookups.lang_english',
      value: 'en',
    },
    {
      label: 'lookups.lang_japanese',
      value: 'jp',
    },
  ];

  selectedLang = '';

  logining = false;

  verifyingOtp = false;

  resendingOtp = false;

  otpCooldown = 0;

  otpCooldownTimer: number | null = null;

  initializing = true;

  private static OTP_STATE_KEY = 'ma-otp-state';

  activeStep = 1;

  ruleForm2 = {
    account: '',
    checkPass: '',
  };

  otpForm = {
    code: '',
  };

  rules2 = {};

  otpRules = {};

  checked = true;

  languageLookup = '';

  isBoa = false;

  otpMeta = {
    hashCheck: '',
    email: '',
  };

  turnstileToken = '';

  turnstileWidgetId: string | number | null = null;

  loginFailureCount = 0;

  turnstileThreshold: number | null = null;
  turnstileEnabled: boolean | null = null;

  turnstileReady = false;

  changeLang(command: string) {
    let defaultLang = 'jp';
    if (isBoa()) {
      defaultLang = 'br';
    }
    const newLang = command || defaultLang;
    window.localStorage.setItem(
      appStorageUtil.CURRENT_USER_LANG,
        newLang,
    );
      this.$i18n.i18next.changeLanguage(newLang).then(() => {
          this.languageLookup = getLanguageLookup();
          this.selectedLang = newLang;
      })
  }

  signIn() {
    this.$refs.ruleForm2.validate((valid) => {
      if (valid) {
        if (this.isTurnstileEnabled && !this.turnstileReady) {
          this.maybeRenderTurnstile();
          return;
        }

        if (this.isTurnstileEnabled && !this.turnstileToken) {
          this.showAlert(
            this.$t('login.err_turnstile').toString(),
            this.$data.SamclickAlert.ERROR,
          );
          return;
        }

        this.logining = true;
        const loginParams = {
          user: this.ruleForm2.account,
          pwd: this.ruleForm2.checkPass,
          system_tag: 'MYA',
          turnstile_token: this.turnstileToken,
        };
        AuthorizationStore.logIn(loginParams).then(
          (response: any) => {
            this.loginFailureCount = 0;
            if (response.status === 206) {
              const otpData = response && response.data && response.data.data ? response.data.data : {};
              this.startOtpFlow(otpData);
              return;
            }

            this.completeLogin();
          },
          (error) => {
            this.logining = false;
            this.loginFailureCount += 1;
            if (!error || (!error.status && !error.data)) {
              this.showAlert(
                this.$t('login.err_service_unavailable').toString(),
                this.$data.SamclickAlert.ERROR,
              );
              this.resetTurnstile();
              return;
            }
            if (error.status === 400 && error.data && error.data.detail) {
              this.showAlert(
                this.resolveErrorMessage(error, 'login.er_login_failed'),
                this.$data.SamclickAlert.ERROR,
              );
            } else if (error.status === 401) {
              this.showAlert(
                this.$t('login.er_login_failed').toString(),
                this.$data.SamclickAlert.ERROR,
              );
            } else if (
            error.status === 403
            && error.data.error === 'EMAIL VERIFIED'
          ) {
            this.showAlert(
              this.$t('login.err_account_waiting').toString(),
              this.$data.SamclickAlert.ERROR,
            );
          } else if (
            error.status === 403
            && error.data.error === 'UNVERIFIED'
          ) {
            this.showUnverifiedDialog();
          }
          this.resetTurnstile();
          this.maybeRenderTurnstile();
          },
        );
      } else {
        this.logining = false;
      }
    });
  }

  @Watch('ifLocaleChange', { immediate: true })
  langChangea(val: string) {
    this.rules2 = {
      account: [
        {
          required: true,
          message: this.$t('login.err_input_user'),
          trigger: 'blur',
        },
      ],
      checkPass: [
        {
          required: true,
          message: this.$t('login.err_input_pass'),
          trigger: 'blur',
        },
      ],
    };

    this.otpRules = {
      code: [
        {
          required: true,
          message: this.$t('login.err_input_otp'),
          trigger: 'blur',
        },
      ],
    };
  }

  goToSignup() {
    this.$router.push({ name: 'signup' });
  }

  resendVerifyEmail() {
    MyaaffiliateStore.resendVerification(
      new Payload({ mail: this.ruleForm2.account }, false),
    ).then((response) => {
      this.showAlert(
        `${this.$t('signup.msg_resend_success')} ${this.ruleForm2.account}`,
        this.$data.SamclickAlert.SUCCESS,
      );
    });
  }

  goToResetPassword() {
    this.$router.push({ name: 'changePass' });
  }

  startOtpFlow(otpData: any) {
    this.logining = false;
    this.activeStep = 2;
    this.otpForm.code = '';
    this.otpMeta = {
      hashCheck: otpData.svc1 || '',
      email: otpData.email || '',
    };
    this.persistOtpState();
    this.startOtpCooldown();
  }

  verifyOtp() {
    this.$refs.otpForm.validate((valid) => {
      if (!valid) {
        return;
      }

      this.verifyingOtp = true;

      AuthorizationStore.verifyOtp(new Payload({
        svc1: this.otpMeta.hashCheck,
        svz45: this.otpMeta.email,
        sxz5: this.otpForm.code,
      }, false)).then(
        () => {
          appStorageUtil.setSessionItem('user', { user: this.ruleForm2.account });
          this.clearOtpState();
          this.completeLogin();
        },
        (error) => {
          if (!error || (!error.status && !error.data)) {
            this.showAlert(
              this.$t('login.err_service_unavailable').toString(),
              this.$data.SamclickAlert.ERROR,
            );
            return;
          }
          this.showAlert(
            this.resolveErrorMessage(error, 'login.otp_error'),
            this.$data.SamclickAlert.ERROR,
          );
        },
      ).finally(() => {
        this.verifyingOtp = false;
      });
    });
  }

  resendOtp() {
    if (!this.otpMeta.email) {
      return;
    }

    this.resendingOtp = true;
    AuthorizationStore.resendOtp(new Payload({ svz45: this.otpMeta.email }, false)).then(
      (response: any) => {
        const otpData = response && response.data && response.data.data ? response.data.data : {};
        this.otpMeta = {
          hashCheck: otpData.svc1 || this.otpMeta.hashCheck,
          email: otpData.email || this.otpMeta.email,
        };
        this.resendingOtp = false;
        this.persistOtpState();
        this.startOtpCooldown();
        this.showAlert(
          this.$t('login.otp_resent').toString(),
          this.$data.SamclickAlert.SUCCESS,
        );
      },
      (error) => {
        if (!error || (!error.status && !error.data)) {
          this.showAlert(
            this.$t('login.err_service_unavailable').toString(),
            this.$data.SamclickAlert.ERROR,
          );
          return;
        }
        this.resendingOtp = false;
        this.showAlert(
          this.resolveErrorMessage(error, 'login.otp_error'),
          this.$data.SamclickAlert.ERROR,
        );
      },
    );
  }

  backToLogin() {
    this.activeStep = 1;
    this.otpForm.code = '';
    this.otpMeta = {
      hashCheck: '',
      email: '',
    };
    this.clearOtpState();
    this.clearOtpCooldown();
    this.resetLoginFailures();
  }

  openTerms() {
    this.$refs.terms.toggleDialog(true);
  }

  enterKey(e: object) {
    if (this.isAllowedElement(e.target.tagName, e.key)) {
      if (this.activeStep === 1) {
        this.signIn();
      } else {
        this.verifyOtp();
      }
    }
  }

  getImage() {
    let loginLogo = require('@/assets/img/logo_login.png');
    if (isBoa()) {
      loginLogo = require('@/assets/img/boabet-red.png');
    }

    return loginLogo;
  }

  getCopyright() {
    let copyrightMessage = '© Copyright 2020 | VJ Group Affiliation - All rights reserved.';
    if (isBoa()) {
      copyrightMessage = 'Copyright © 2023 Simplicity Malta Limited. All rights reserved.';
    }

    return copyrightMessage;
  }

  completeLogin() {
    AuthorizationStore.getMyDetails(
      new Payload({ token: AuthorizationStore.getTokenInState }),
    ).then((response) => {
      const affInfo = response.data || {};
      if (!this.validateAffiliateStatus(affInfo)) {
        return;
      }

      const selectedLang = affInfo.preferred_language;
      window.localStorage.setItem(
        appStorageUtil.CURRENT_USER_LANG,
        selectedLang,
      );
      window.localStorage.setItem(appStorageUtil.BANNER_IS_CLOSED, false);
      this.$i18n.i18next.changeLanguage(selectedLang);
      this.$router.push(
        this.$route.query.redirectFrom !== undefined
          ? { path: `${this.$route.query.redirectFrom}` }
          : { name: 'dashboard' },
      );
    }).catch(() => {
      const fallbackLang = window.localStorage.getItem(appStorageUtil.CURRENT_USER_LANG)
        || this.$i18n.i18next.language;
      window.localStorage.setItem(appStorageUtil.CURRENT_USER_LANG, fallbackLang);
      window.localStorage.setItem(appStorageUtil.BANNER_IS_CLOSED, false);
      this.$i18n.i18next.changeLanguage(fallbackLang);
      this.$router.push(
        this.$route.query.redirectFrom !== undefined
          ? { path: `${this.$route.query.redirectFrom}` }
          : { name: 'dashboard' },
      );
    }).finally(() => {
      this.logining = false;
    });
  }

  resolveErrorMessage(error: any, fallbackKey: string) {
    if (error && error.data && error.data.localization_code) {
      return this.$t(error.data.localization_code).toString();
    }

    if (error && error.data && error.data.detail) {
      const detail = error.data.detail;
      if (typeof detail === 'string' && detail.indexOf('.') >= 0) {
        return this.$t(detail).toString();
      }
      return detail.toString();
    }

    return this.$t(fallbackKey).toString();
  }

  validateAffiliateStatus(affInfo: any) {
    const status = affInfo && typeof affInfo.status === 'number' ? affInfo.status : null;
    if (status === Login.AFFILIATE_STATUS_VERIFIED) {
      return true;
    }

    AuthorizationStore.logout();
    removeAuthentication();
    this.clearOtpState();
    this.clearOtpCooldown();
    this.activeStep = 1;
    this.otpForm.code = '';
    this.otpMeta = {
      hashCheck: '',
      email: '',
    };

    if (status === Login.AFFILIATE_STATUS_UNVERIFIED) {
      this.showUnverifiedDialog();
      return false;
    }

    this.showAlert(
      this.$t('login.err_account_waiting').toString(),
      this.$data.SamclickAlert.ERROR,
    );
    return false;
  }

  showUnverifiedDialog() {
    const h = this.$createElement;
    this.$confirm(
      h('p', null, [
        h('p', null, this.$t('login.err_acct_verification_1')),
        h('p', null, this.$t('login.err_acct_verification_2')),
        h('br'),
        h('p', null, this.$t('login.err_acct_verification_3')),
      ]),
      this.$t('api_error.header_error').toString(),
      {
        confirmButtonText: this.$t(
          'login.btn_resend_verification',
        ).toString(),
        type: 'error',
        center: true,
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonText: this.$t('buttons.cancel').toString(),
      },
    )
      .then(() => {
        this.resendVerifyEmail();
      })
      .catch(() => {});
  }

  startOtpCooldown(remainingSeconds?: number) {
    this.otpCooldown = typeof remainingSeconds === 'number' ? remainingSeconds : 60;
    this.persistOtpState();
    this.clearOtpCooldown(false);
    this.otpCooldownTimer = window.setInterval(() => {
      if (this.otpCooldown <= 1) {
        this.clearOtpCooldown();
        return;
      }
      this.otpCooldown -= 1;
    }, 1000);
  }

  clearOtpCooldown(resetValue: boolean = true) {
    if (this.otpCooldownTimer !== null) {
      window.clearInterval(this.otpCooldownTimer);
      this.otpCooldownTimer = null;
    }
    if (resetValue) {
      this.otpCooldown = 0;
    }
  }

  persistOtpState() {
    if (!this.otpMeta || !this.otpMeta.hashCheck || !this.otpMeta.email) {
      return;
    }
    const cooldownEndsAt = Date.now() + (this.otpCooldown > 0 ? this.otpCooldown : 60) * 1000;
    window.sessionStorage.setItem(Login.OTP_STATE_KEY, JSON.stringify({
      hashCheck: this.otpMeta.hashCheck,
      email: this.otpMeta.email,
      cooldownEndsAt,
    }));
  }

  clearOtpState() {
    window.sessionStorage.removeItem(Login.OTP_STATE_KEY);
  }

  translateLoginKey(fullKey: string) {
    const translated = this.$t(fullKey).toString();
    if (translated !== fullKey) {
      return translated;
    }

    const innerKey = fullKey.startsWith('login.') ? fullKey.slice(6) : fullKey;
    const currentLang = this.selectedLang || this.$i18n.i18next.language || 'en';
    const normalizedLang = currentLang === 'jp' || currentLang === 'ja' ? 'ja' : 'en';
    const fallbackLocale: any = normalizedLang === 'ja' ? (jaLocale as any) : (enLocale as any);
    const fallbackValue = fallbackLocale && fallbackLocale.login ? fallbackLocale.login[innerKey] : '';
    return fallbackValue || translated;
  }

  restoreOtpState() {
    const rawState = window.sessionStorage.getItem(Login.OTP_STATE_KEY);
    if (!rawState) {
      return;
    }
    try {
      const parsed = JSON.parse(rawState);
      if (!parsed || !parsed.hashCheck || !parsed.email) {
        this.clearOtpState();
        return;
      }
      this.activeStep = 2;
      this.otpForm.code = '';
      this.otpMeta = {
        hashCheck: parsed.hashCheck,
        email: parsed.email,
      };
      const remaining = parsed.cooldownEndsAt ? Math.ceil((parsed.cooldownEndsAt - Date.now()) / 1000) : 0;
      if (remaining > 0) {
        this.startOtpCooldown(remaining);
      } else {
        this.clearOtpCooldown();
      }
    } catch (error) {
      this.clearOtpState();
    }
  }

  async getDefaultLanguage(): Promise<void> {
    return CommonsStore.getDefaultLanguage()
      .then((response) => {
        const res = response as { data: string };
        const rawLanguage = res.data;
        const language = rawLanguage ? rawLanguage.toLowerCase() : "";

        const isJapanese = language === "ja" || language === "jp";
        const selectedLanguage = isJapanese ? language : "en";

        window.localStorage.setItem(appStorageUtil.CURRENT_USER_LANG, selectedLanguage);
      }).catch(() => {
        window.localStorage.setItem(appStorageUtil.CURRENT_USER_LANG, "en");
      });
  }

  beforeMount() {
    removeAuthentication()
    this.isBoa = isBoa();
  }

  async mounted() {
    await this.getDefaultLanguage();

    const localLanguage = window.localStorage.getItem(appStorageUtil.CURRENT_USER_LANG) || "";

    if (localLanguage !== "") {
      this.$i18n.i18next.changeLanguage(localLanguage).then(() => {
        this.selectedLang = localLanguage;
        this.languageLookup = getLanguageLookup();
      });
    } else {
      this.selectedLang = this.$i18n.i18next.language;
    }

    try {
      const response = await CommonsStore.getTurnstileConfig();
      const data = response && response.data ? response.data : {};
      if (typeof data.enforce_after_failed_attempts === 'number') {
        this.turnstileThreshold = data.enforce_after_failed_attempts;
      }
      if (typeof data.enabled === 'number') {
        this.turnstileEnabled = data.enabled === 1;
      }
    } catch (error) {
      // fallback to env configuration
    }

    this.maybeRenderTurnstile();
    this.restoreOtpState();
    this.initializing = false;
  }

  get isTurnstileEnabled() {
    if (this.turnstileEnabled !== null && !this.turnstileEnabled) {
      return false;
    }
    return !!this.turnstileSiteKey && this.shouldRequireTurnstile;
  }

  get turnstileSiteKey() {
    const multi = process.env.VUE_APP_TURNSTILE_SITE_KEYS || '';
    if (!multi) {
      return process.env.VUE_APP_TURNSTILE_SITE_KEY || '';
    }

    const hostname = window.location.hostname;
    const entries = multi.split(',').map(entry => entry.trim()).filter(entry => entry);
    for (const entry of entries) {
      const parts = entry.split('=');
      if (parts.length !== 2) {
        continue;
      }
      const host = parts[0].trim();
      const key = parts[1].trim();
      if (host === hostname) {
        return key;
      }
    }

    return process.env.VUE_APP_TURNSTILE_SITE_KEY || '';
  }

  get shouldRequireTurnstile() {
    const threshold = this.turnstileThreshold !== null
      ? this.turnstileThreshold
      : parseInt(process.env.VUE_APP_TURNSTILE_AFTER_FAILED_ATTEMPTS || '', 10);
    if (Number.isNaN(threshold) || threshold <= 0) {
      return false;
    }
    return this.loginFailureCount >= threshold;
  }

  maybeRenderTurnstile() {
    if (!this.isTurnstileEnabled) {
      return;
    }

    if (this.turnstileWidgetId !== null) {
      return;
    }

    this.renderTurnstile();
  }

  renderTurnstile() {
    if (!this.isTurnstileEnabled) {
      return;
    }

    const turnstile = (window as any).turnstile;
    if (!turnstile) {
      setTimeout(() => this.renderTurnstile(), 300);
      return;
    }

    const container = document.getElementById('turnstile-widget');
    if (!container) {
      setTimeout(() => this.renderTurnstile(), 300);
      return;
    }

    this.turnstileWidgetId = turnstile.render(container, {
      sitekey: this.turnstileSiteKey,
      callback: (token: string) => {
        this.turnstileToken = token;
      },
      'expired-callback': () => {
        this.turnstileToken = '';
      },
      'error-callback': () => {
        this.turnstileToken = '';
      },
    });
    this.turnstileReady = true;
  }

  resetTurnstile() {
    const turnstile = (window as any).turnstile;
    if (turnstile && this.turnstileWidgetId !== null) {
      turnstile.reset(this.turnstileWidgetId);
      this.turnstileToken = '';
    }
  }

  resetLoginFailures() {
    this.loginFailureCount = 0;
    this.turnstileToken = '';
    this.turnstileReady = false;
    if (this.turnstileWidgetId !== null) {
      const container = document.getElementById('turnstile-widget');
      if (container) {
        container.innerHTML = '';
      }
      this.turnstileWidgetId = null;
    }
  }

  beforeDestroy() {
    this.clearOtpCooldown();
    this.resetTurnstile();
  }
}
